import { useState, useEffect } from 'react'
import { useLocation } from 'react-router'

const MD_BREAKPOINT = 768

export function useMobileMenu() {
  const [isOpen, setIsOpen] = useState(false)
  const { pathname } = useLocation()

  // Close on route change
  useEffect(() => {
    setIsOpen(false)
  }, [pathname])

  // Close when resizing past md breakpoint
  useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${MD_BREAKPOINT}px)`)
    function handleChange(e: MediaQueryListEvent) {
      if (e.matches) setIsOpen(false)
    }
    mql.addEventListener('change', handleChange)
    return () => mql.removeEventListener('change', handleChange)
  }, [])

  return [isOpen, setIsOpen] as const
}
